export default {
  BRANCH_TYPE_FULL_PAYMENT: 'full_payment',
  BRANCH_TYPE_DEPOSIT: 'deposit',
}
